import { CSVTextEntry } from '../../../FilterResultsManager/components';
import { TextEntryFilterOption } from '../../../FilterResultsManager/options/types';

export const config: TextEntryFilterOption = {
  id: 'jaxCancerEffectContent.filters.variantDescription',
  title: {
    id: 'jaxCancerEffectContent.filters.variantDescription',
    defaultMessage: 'Variant Description',
  },
  content: CSVTextEntry,
  injectedProps: {
    searchKey: '~variant_description',
    textEntryOption: {
      id: 'jaxCancerEffectContent.filters.variantDescription',
      searchValue: '',
      placeholderIntlLabel: {
        id: 'jaxCancerEffectContent.filters.variantDescription.placeholder',
        defaultMessage: 'Variant Description',
      },
    },
  },
};
